var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationProvider', {
    staticClass: "form-group w-full v-select",
    class: _vm.$attrs.class,
    attrs: {
      "mode": _vm.customValidate,
      "rules": _vm.rules,
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors,
          classes = _ref.classes;
        return [_vm.label ? _c('label', {
          staticClass: "block mb-1",
          class: _vm.labelClass
        }, [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('b', {
          staticClass: "ml-1 text-red-600 font-bold"
        }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('div', {
          staticClass: "relative input-group"
        }, [_c('VueSelect', _vm._g(_vm._b({
          ref: "select",
          staticClass: "form-control",
          class: _vm.hasData ? 'has-data' : '',
          attrs: {
            "append-to-body": true,
            "autoscroll": true,
            "clearable": _vm.clearable,
            "deselectFromDropdown": _vm.multiple,
            "disabled": _vm.disabled,
            "filterable": false,
            "get-option-key": function (option) {
              return option === null || option === void 0 ? void 0 : option.id;
            },
            "get-option-label": function (option) {
              return option && option[_vm.fieldLabel] ? option[_vm.fieldLabel] : '';
            },
            "label": _vm.fieldLabel,
            "multiple": _vm.multiple,
            "options": _vm.paginated,
            "placeholder": _vm.placeholder,
            "pushTags": true,
            "reduce": function (option) {
              return !_vm.returnObj ? option === null || option === void 0 ? void 0 : option.id : option;
            },
            "taggable": _vm.taggable
          },
          on: {
            "close": _vm.onClose,
            "open": _vm.onOpen,
            "search": _vm.onSearch
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function (_ref2) {
              var id = _ref2.id,
                text = _ref2.text;
              return [_c('div', {
                class: [{
                  'font-bold': _vm.isSelectedOptionItem(id)
                }]
              }, [_vm._v(_vm._s(text))])];
            }
          }, {
            key: "no-options",
            fn: function (_ref3) {
              var search = _ref3.search,
                searching = _ref3.searching;
              return [_c('div', {
                staticClass: "px-3 py-2 text-center"
              }, [!_vm.loading ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("No items in select")))]) : _vm._e()])];
            }
          }, {
            key: "list-footer",
            fn: function () {
              return [_c('li', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading"
                }],
                ref: "load",
                staticClass: "list-footer"
              }, [_c('i', {
                staticClass: "fa-solid fa-spin fa-circle-notch"
              }), _vm._v(" " + _vm._s(_vm.$t('Data loading')) + " ")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.dropdownValue,
            callback: function ($$v) {
              _vm.dropdownValue = $$v;
            },
            expression: "dropdownValue"
          }
        }, 'VueSelect', _vm.$attrs, false), _vm.$listeners))], 1), !!_vm.hint ? _c('span', {
          staticClass: "text-xs text-gray-400",
          class: _vm.hintClass
        }, [_vm._v(_vm._s(_vm.hint))]) : _vm._e(), _c('span', {
          staticClass: "text-xs text-red-600"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }